import { useSelector, useDispatch } from 'react-redux';
import FJActionFake3d from '../../../../redux/action/FJActionFake3d';
import FJFake3dExport from './FJFake3dExport';
import { setExportFormate, setExportResolution } from '../../../../redux/slices/FJSliceFake3d';
import FJFake3dExportStore from '../../../../store/FJFake3dExportStore';
import useLocalStore from '../../../../hooks/useLocalStore';
import FJActionEditPage from '../../../../redux/action/FJActionEditPage.js';

const FJFake3dExportContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const exportFormate = useSelector(state => state.fake3d.exportFormate);
    const exportResolution = useSelector(state => state.fake3d.exportResolution);
    const settingStep = useSelector(state => state.fake3d.settingStep);
    const exportProgress = useSelector(state => state.fake3d.exportProgress);
    const isApplyButton = useSelector(state => state.common.isApplyButton);
    const onExport = () => {
        dispatch(FJActionFake3d.exportAction());
    };
    const onExportFormateChange = value => {
        dispatch(setExportFormate(value));
    };
    const onExportResolutionChange = value => {
        dispatch(setExportResolution(value));
    };
    const backExport = () => {
        dispatch(FJActionFake3d.backExportAction());
    };
    const download = () => {
        FJFake3dExportStore.download(false);
    };

    const _onApply = () => {
        const blobInfo = FJFake3dExportStore.getBlobInfo();
        const { blob, fileName, mimeType } = blobInfo;
        blob.name = fileName;
        blob.mimeType = mimeType;
        // blob.type = mimeType;
        dispatch(FJActionEditPage.applyToEditPageAction(blob));
    };

    const _onAddToMediaLibrary = () => {
        const blobInfo = FJFake3dExportStore.getBlobInfo();
        const { blob, fileName, mimeType } = blobInfo;
        blob.name = fileName;
        blob.mimeType = mimeType;
        // blob.type = mimeType;
        dispatch(FJActionEditPage.addToMediaLibraryAction(blob, { from: 'generate' }));
    };

    return (
        <FJFake3dExport
            onExport={onExport}
            exportFormate={exportFormate}
            exportResolution={exportResolution}
            onExportFormateChange={onExportFormateChange}
            onExportResolutionChange={onExportResolutionChange}
            settingStep={settingStep}
            backExport={backExport}
            exportProgress={exportProgress}
            download={download}
            useApplyButton={isApplyButton}
            onApply={_onApply}
            onAddToMediaLibrary={_onAddToMediaLibrary}
        />
    );
};

export default FJFake3dExportContainer;
